import { component } from 'picoapp';
import Swiper, { SwiperOptions, Navigation } from 'swiper';
import { image } from '~/js/utils/image';
import placeholderImage from '~/js/components/placeholder-image';

export default component((node: HTMLElement, ctx: Picoapp.Ctx) => {
  /**
   * TS declarations
   */
  interface Elems {
    container: HTMLElement;
    colorNameElem: HTMLElement;
    moreLinked: HTMLElement;
  }

  interface Vars {
    linkedTag: string;
    handle: string;
    currentColor: string;
  }

  /**
   * DOM elems + vars
   */
  const elems: Elems = {
    container: node.querySelector('[data-linked-products-grid]'),
    colorNameElem: node.querySelector('[data-color-name]'),
    moreLinked: node.querySelector('[data-more-linked]'),
  };

  const vars: Vars = {
    linkedTag: node.dataset.linkedTag,
    handle: node.dataset.handle,
    currentColor: node.dataset.currentColor,
  };

  /**
   * Functions
   */
  // Find matching products
  ctx.on('linkedProducts:fetched', ({ allLinkedProducts }) => {
    const productsWithLinkedTag = allLinkedProducts.filter((product) => product.tags.find((tag) => tag.includes('linked_')));
    const linkedProducts = productsWithLinkedTag.filter((p) => p.tags.find((tag) => tag.includes(vars.linkedTag))); // eslint-disable-line
    const hasImage = linkedProducts.filter((lp) => lp.images.length > 0);

    if (!linkedProducts || hasImage.length < 0) return;

    // Show '+ more'
    if (linkedProducts.length > 5 && window.innerWidth > 640) {
      elems.moreLinked.classList.remove('hidden');
    }

    // Render matching products
    elems.container.innerHTML = linkedProducts.map((linkedProduct) => {
      const { tags } = linkedProduct;
      const colorTag = tags.find((tag) => tag.includes('color_'));
      const colorName = colorTag?.replace('color_', '');

      if (linkedProduct.images.length === 0) return '';

      return `
        <div class="swiper-slide">
          <a class="product__linked-products__item block transition-opacity duration-300 ease-in-out border ${vars.handle === linkedProduct.handle ? 'border-black active' : ''}" href="/products/${linkedProduct.handle}" data-color-name="${colorName}" data-linked-product-item>
            <div class="aspect-ratio aspect-ratio--2/3 image__filter--grey">
              ${linkedProduct.images.length > 0 ? image(linkedProduct.images[0], 'mix-blend-multiply', 2 / 3) : placeholderImage()}
            </div>
          </a>
        </div>
      `;
    }).join('');

    // Init slider
    const sliderElem: HTMLElement = node.querySelector('[data-linked-products-slider]');
    const swiperConfig: SwiperOptions = {
      modules: [Navigation],
      slidesPerView: 5,
      init: false,
      loopPreventsSlide: true,
      spaceBetween: 8,
      navigation: {
        nextEl: '.linked-button-next',
      },
    };

    const carousel = new Swiper(sliderElem, swiperConfig);
    carousel.init();

    // Change color name on hover
    const linkedProductItems = node.querySelectorAll('[data-linked-product-item]');
    linkedProductItems.forEach((productItem: HTMLElement) => {
      const color = productItem.dataset.colorName;

      productItem.addEventListener('mouseenter', () => {
        if (color === 'undefined') return;
        elems.colorNameElem.textContent = color;
      });

      productItem.addEventListener('mouseleave', () => {
        if (color === 'undefined') return;
        elems.colorNameElem.textContent = vars.currentColor;
      });
    });
  });

  // Fetch all products
  const fetchProducts = async () => {
    const response = await fetch('/collections/all?view=data').then((resp) => resp.json());
    ctx.emit('linkedProducts:fetched', ({ allLinkedProducts: response }));
    window.sessionStorage.setItem('linkedProducts', JSON.stringify(response));
  };

  if (window.sessionStorage.getItem('linkedProducts')) {
    const allProducts = JSON.parse(window.sessionStorage.getItem('linkedProducts'));
    ctx.emit('linkedProducts:fetched', ({ allLinkedProducts: allProducts }));
  } else {
    fetchProducts();
  }
});
